import { StaticBaseUrl } from './Constants';
import Api from "./Api";
import Csrf from "./Csrf";

export default {

    getIconAttribute(iconid, styleid){
        let s = styleid > 1 ? '_'+styleid : ''; 
        return StaticBaseUrl +'/icons/attributes/'+iconid+s+'.svg';
    },

    getIconAllergen(iconid, styleid){
        let s = styleid > 1 ? '_'+styleid : ''; 
        return StaticBaseUrl +'/icons/allergens/'+iconid+s+'.svg';
    },

    getIconCat(url){
        return StaticBaseUrl +url;
    },

    getDishImage(url){
        return StaticBaseUrl +url;
    },

    getImage(url,format){
        return StaticBaseUrl +url+"."+format;
    },
    

    async getIcons() {
        await Csrf.getCookie();

        return Api.get("/icons");
    },

}